import { Table, Text, useToggle } from '@factorialco/deprecated-design-system'
import type { Currency } from 'dinero.js'
import { PayrollConceptFragment } from 'generated/resources/graphql'

import { ExplotableItem, ExplotableList } from 'modules/core/components/GroupingExplotable'
import i18n from 'modules/core/lib/i18n'

import type {
  LabelMappedWithAI,
  LabelToConceptId,
} from 'modules/payroll_bundle/components/PayrollSummaryImport/PayrollSummaryImportModal/ImportSummaryWizard/types'
import { formatAmount } from 'modules/payroll_bundle/lib/formatNumber'

import ConceptSelectorForLabel from './ConceptSelectorForLabel'

export interface conceptLine {
  conceptId?: number | null
  fieldName: string
  sample?: string | null
  type?: string | null
}

interface Props {
  currency: Currency
  lines: conceptLine[]
  concepts: PayrollConceptFragment[]
  labelToConceptId: LabelToConceptId
  labelMappedWithAI: LabelMappedWithAI
  onUpdateLabelToConceptId: (labelToConceptId: LabelToConceptId) => void
  onUpdateLabelMappedWithAI: (labelMappedWithAI: LabelMappedWithAI) => void
}

const ConceptsGroup = ({
  currency,
  lines,
  concepts,
  labelToConceptId,
  labelMappedWithAI,
  onUpdateLabelToConceptId,
  onUpdateLabelMappedWithAI,
}: Props) => {
  const [open, toggle] = useToggle(true)

  return (
    <ExplotableList>
      <ExplotableItem
        opened={open}
        toggle={toggle(!open)}
        headerBorders={false}
        renderHeader={() => (
          <Text.Normal size="200" weight="medium" color="grey800">
            {i18n.t('payroll_bundle.results_payments.result_upload.map_to_concepts.concepts')}
          </Text.Normal>
        )}
        scrollLimited={false}
        size="small"
      >
        <Table noRadius hideBorder>
          {lines.map((line, index) => (
            <Table.Row key={line.fieldName + line?.sample}>
              <Table.Cell>
                <Text.Normal>{line.fieldName}</Text.Normal>
              </Table.Cell>
              <Table.Cell>
                <Text.Normal color="grey700">
                  {formatAmount(Number(line.sample), currency)}
                </Text.Normal>
              </Table.Cell>
              <Table.Cell>
                <ConceptSelectorForLabel
                  label={line.fieldName}
                  concepts={concepts}
                  readonly={index === 0}
                  labelToConceptId={labelToConceptId}
                  labelMappedWithAI={labelMappedWithAI}
                  onUpdateLabelToConceptId={onUpdateLabelToConceptId}
                  onUpdateLabelMappedWithAI={onUpdateLabelMappedWithAI}
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table>
      </ExplotableItem>
    </ExplotableList>
  )
}

export default ConceptsGroup
